import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Alert,
  Checkbox,
  Modal,
  Radio,
  Space,
  Typography,
} from 'antd';
import { MOTIVOS_CANCELACION, MOTIVO_SIN_OPERACION } from 'api/nominas/timbrado';

const { Text } = Typography;

export const AVISO_MOTIVO_03 = 'Use 03 solo si el pago que ampara este CFDI no se realizó. Si el '
  + 'pago se hizo y el CFDI tiene errores de datos o importes, no corresponde el 03.';
export const CONFIRMACION_MOTIVO_03 = 'Confirmo que la operación no se realizó';
export const AVISO_EJERCICIO_ANTERIOR = 'Este CFDI pertenece a un ejercicio fiscal anterior. La ley '
  + 'fija un plazo para cancelar los CFDI de cada ejercicio; confírmelo con el área fiscal y '
  + 'contable antes de continuar. El resultado lo determinan el SAT y el proveedor de timbrado.';

/**
 * Diálogo de motivo de cancelación de timbrado (ticket 37, TC-1), común a la cancelación
 * de un recibo y a Cancelar Todo. Sin motivo preseleccionado; el 03 exige confirmar que
 * la operación no se realizó. El aviso de ejercicio anterior es informativo.
 */
const DialogoCancelacionTimbrado = ({
  open,
  titulo,
  ejercicioAnterior,
  loading,
  onConfirmar,
  onCancelar,
}) => {
  const [motivo, setMotivo] = useState(null);
  const [operacionNoRealizada, setOperacionNoRealizada] = useState(false);

  // Cada apertura empieza sin motivo ni confirmación
  useEffect(() => {
    if (open) {
      setMotivo(null);
      setOperacionNoRealizada(false);
    }
  }, [open]);

  const onCambiarMotivo = (e) => {
    setMotivo(e.target.value);
    // La confirmación del 03 no se arrastra a otro motivo ni de regreso
    setOperacionNoRealizada(false);
  };

  const puedeConfirmar = !!motivo && (motivo !== MOTIVO_SIN_OPERACION || operacionNoRealizada);

  return (
    <Modal
      open={open}
      title={titulo}
      okText="Solicitar Cancelación"
      cancelText="Cerrar"
      onOk={() => puedeConfirmar && onConfirmar(motivo)}
      onCancel={onCancelar}
      okButtonProps={{ disabled: !puedeConfirmar }}
      confirmLoading={loading}
      destroyOnClose
    >
      {ejercicioAnterior && (
        <Alert type="info" showIcon message={AVISO_EJERCICIO_ANTERIOR} style={{ marginBottom: 16 }} />
      )}
      <Text strong>Motivo de Cancelación</Text>
      <Radio.Group
        aria-label="Motivo de Cancelación"
        value={motivo}
        onChange={onCambiarMotivo}
        style={{ display: 'block', marginTop: 8 }}
      >
        <Space direction="vertical">
          {MOTIVOS_CANCELACION.map(({ clave, nombre, explicacion }) => (
            <Radio key={clave} value={clave}>
              {`${clave} - ${nombre}`}
              <br />
              <Text type="secondary">{explicacion}</Text>
            </Radio>
          ))}
        </Space>
      </Radio.Group>
      {motivo === MOTIVO_SIN_OPERACION && (
        <>
          <Alert type="warning" showIcon message={AVISO_MOTIVO_03} style={{ marginTop: 16 }} />
          <Checkbox
            checked={operacionNoRealizada}
            onChange={(e) => setOperacionNoRealizada(e.target.checked)}
            style={{ marginTop: 8 }}
          >
            {CONFIRMACION_MOTIVO_03}
          </Checkbox>
        </>
      )}
    </Modal>
  );
};

DialogoCancelacionTimbrado.propTypes = {
  open: PropTypes.bool.isRequired,
  titulo: PropTypes.string,
  ejercicioAnterior: PropTypes.bool,
  loading: PropTypes.bool,
  onConfirmar: PropTypes.func.isRequired,
  onCancelar: PropTypes.func.isRequired,
};

DialogoCancelacionTimbrado.defaultProps = {
  titulo: '',
  ejercicioAnterior: false,
  loading: false,
};

export default DialogoCancelacionTimbrado;
